import React from 'react'
import { useTrans } from 'hooks'
import { CategoriaNode } from '@gql/graphql'
import { ListingHead, Page, PowerBar, ProdottiListing, TextSection } from 'components/organisms'
import styles from './ProdottiListingTemplate.module.sass'
import { MenuItemType } from '@utils/types'
import { JsonLd } from '@components/atoms'

interface Props {
  pagina?: any
  categoria?: CategoriaNode
  listing?: any
}

const ProdottiListingTemplate = (props: Props) => {
  const { pagina = {}, categoria = undefined, listing = undefined } = props

  const t = useTrans()

  const items = categoria?.depth === 2 ? categoria?.children : categoria?.siblings

  const powerBarItems: (MenuItemType & { selected?: boolean })[] =
    items?.map((c) => ({
      pk: c.pk,
      name: `${c.nome}`,
      url: c.url,
      selected: categoria?.pk === c.pk,
    })) || []

  const powerBarAllItem: MenuItemType & { selected?: boolean } = {
    pk: 'all',
    name: t('Tutti i prodotti'),
    selected:
      (categoria?.depth === 2 || (categoria.depth === 3 && categoria?.children?.length > 0)) &&
      powerBarItems.filter((x) => x.selected).length === 0,
    url: categoria?.depth === 2 ? categoria.url : categoria?.parent?.url,
  }

  const testoSeoItem = {
    name: categoria.sottoTitolo,
    description: categoria.guidaDettagliata,
  }

  const isAttivita = categoria.parent?.alias?.toLowerCase()?.includes('attività')

  return (
    <Page pagina={pagina} item={categoria} className={`${styles.root}`}>
      <main className={styles.main}>
        <ListingHead
          pagina={{
            ...pagina,
            titolo: pagina?.seo?.h1 || categoria.nome,
            descrizione: categoria.guidaBreve,
            mainImage: categoria.depth < 3 && !isAttivita ? categoria.mainImage : null,
          }}
          className={styles.head}
        />
        {!!powerBarItems?.length && (
          <PowerBar items={[powerBarAllItem].concat(powerBarItems)} className={styles.powerBar} />
        )}
        <ProdottiListing categoria={categoria} listing={listing} />
        <TextSection item={testoSeoItem} size="sm" align="left" />
        <JsonLd type="product_aggregate_offer" listing={listing} />
        <JsonLd type="itemList" listing={listing} />
      </main>
    </Page>
  )
}

export default ProdottiListingTemplate
